import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import 'hammerjs';
import { NgxHmCarouselModule } from 'ngx-hm-carousel';
import { AppMaterialModule } from '../../../app/app-material.module';
import { SharedModule } from '../shared/shared.module';
import { FeaturedProductsComponent } from './featured-products/featured-products.component';
import { ImageFallbackDirective } from './image-fallback.directive';
import { MarketingRoutingModule } from './marketing-routing.module';
import { CategoriesComponent } from './products/categories/categories.component';
import { PriceAsComponent } from './products/product-details/price-as/price-as.component';
import { ProductDetailsComponent } from './products/product-details/product-details.component';
import { ProductsSearchResultsComponent } from './products/products-search/products-search-results.component';
import { ProductsComponent } from './products/products.component';
import { SearchProductComponent } from './products/search-product/search-product.component';
import { ProductImagesComponent } from './products/product-images/product-images.component';
import { LastQuotesListComponent } from './products/product-details/last-quotes-list/last-quotes-list.component';
import { ProductNotificationDialogComponent } from './products/product-notification-dialog/product-notification-dialog.component';

@NgModule({
  declarations: [
    ProductsComponent,
    CategoriesComponent,
    ProductDetailsComponent,
    FeaturedProductsComponent,
    ProductsSearchResultsComponent,
    SearchProductComponent,
    ImageFallbackDirective,
    ProductImagesComponent,
    PriceAsComponent,
    LastQuotesListComponent,
    ProductNotificationDialogComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    MarketingRoutingModule,
    NgxHmCarouselModule,
    AppMaterialModule,
    SharedModule,
  ]
})
export class MarketingModule { }
